/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Paging metadata for list resource responses
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * Total resource count
     * @type {number}
     * @memberof Metadata
     */
    totalCount: number;
    /**
     * Total page count
     * @type {number}
     * @memberof Metadata
     */
    totalPages: number;
    /**
     * Current page index
     * @type {number}
     * @memberof Metadata
     */
    currentPage: number;
    /**
     * Previous page URI
     * @type {string}
     * @memberof Metadata
     */
    prevPage: string;
    /**
     * Next page URI
     * @type {string}
     * @memberof Metadata
     */
    nextPage: string;
}

/**
 * Check if a given object implements the Metadata interface.
 */
export function instanceOfMetadata(value: object): value is Metadata {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('currentPage' in value) || value['currentPage'] === undefined) return false;
    if (!('prevPage' in value) || value['prevPage'] === undefined) return false;
    if (!('nextPage' in value) || value['nextPage'] === undefined) return false;
    return true;
}

export function MetadataFromJSON(json: any): Metadata {
    return MetadataFromJSONTyped(json, false);
}

export function MetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): Metadata {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['total_count'],
        'totalPages': json['total_pages'],
        'currentPage': json['current_page'],
        'prevPage': json['prev_page'],
        'nextPage': json['next_page'],
    };
}

export function MetadataToJSON(value?: Metadata | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total_count': value['totalCount'],
        'total_pages': value['totalPages'],
        'current_page': value['currentPage'],
        'prev_page': value['prevPage'],
        'next_page': value['nextPage'],
    };
}

